import React from 'react';
import HomePublic from './HomeView.pub';
import HomeStatistics from './HomeView.statistics';
import HomeOpNav from './HomeView.op';
import HomeWorkerSchedule from './HomeView.worker';

import Auth from 'service/auth';

class HomeView extends React.Component
{
  render()
  {
    if ( Auth.User )
    {
      switch (Auth.User.Role)
      {
        case 'SYSTEM': return <p className="message red">正在使用系統賬號登入</p>;
        case 'ADMIN':
        case 'VIEWER_SU':
          return <HomeStatistics />;
        case 'OPERATOR':
        case 'VIEWER_DAY':
        case 'VIEWER_NIGHT':
          return <HomeOpNav />;
        case 'WORKER':
          return <HomeWorkerSchedule />;
        default:
          return <div>系統錯誤，無法識別此使用者。</div>;
      }
    }
    return <HomePublic />;
  }

}

export default HomeView;